<template>
  <ModalDialog :closeable="$t('common.close')" :open.sync="IsOpen" size='small'>
        <h3 v-html="$t('ean.whereFoundEan.title')"></h3>
        <p>
          <span v-html="$t('ean.whereFoundEan.invoice')"></span>
          <br>
          <span v-html="$t('ean.whereFoundEan.formOnline1')"></span>
          <button class='lib__no-margin lib__chat_trigger lib__btn lib__btn--primary lib__btn--small' @click='openChat'>
            <i class='fas fa-comments'></i></button>
          <br>
          <span v-html="$t('ean.whereFoundEan.formOnline2')"></span>
        </p>
      </ModalDialog>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { chatService } from '@/services'

@Component
export default class FindEanModalDialog extends Vue {
  //#region [Property]
  @Prop({ type: Boolean, required: true })
  public readonly value!: boolean
  //#endregion

  //#region [Data]
  @State('lang')
  public lang!: string | null
  //#endregion

  //#region [Computed]
  public get IsOpen(): boolean {
    return this.value
  }

  public set IsOpen(val: boolean) {
    this.$emit('input', val)
  }
  //#endregion

  //#region [Method]
  public openChat() {
    chatService.openChat()
  }
  //#endregion
}
</script>